import { render, staticRenderFns } from "./HoursFrameMenu.vue?vue&type=template&id=4fb2d0ea&"
import script from "./HoursFrameMenu.vue?vue&type=script&lang=js&"
export * from "./HoursFrameMenu.vue?vue&type=script&lang=js&"
import style0 from "./HoursFrameMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports